import { render } from "./ManageResep.vue?vue&type=template&id=b2f8b044"
import script from "./ManageResep.vue?vue&type=script&lang=js"
export * from "./ManageResep.vue?vue&type=script&lang=js"

import exportComponent from "C:\\WORK\\Tamani\\admin-landing\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__